export type ServiceName = 'pam' | 'ntl' | 'sqw' | 'cml' | 'nrc' | 'neo' | 'scr' | 'cml-v2'

export class TimeoutError extends Error {
    constructor(message = 'Request timeout') {
        super(message)
        this.name = 'TimeoutError'
    }
}
